var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('div',_vm._l((_vm.rows),function(row){return _c('div',{key:row,staticClass:"skeleton",style:(_vm.cssVariables)})}),0):_vm._e(),(!_vm.show)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }